export const AdditionalValesMenuItems = [
  {
    label: 'View details',
    key: 'manage'
  }
]
